// extracted by mini-css-extract-plugin
export default {"container":"fHNlng3TrgBtgxtlhlyT","wrapper":"OzPrXwMqctD7IbKpwMaN","body":"Vjsf7PM3M_mHtFDXVxvK","link":"e22z2nYLOG9iwoNrcsxn"};